import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import DocumentDefinitionsEditor from "./DocumentDefinitionsEditor";
import { useAuthenticatedRequest } from "./hooks/useAuthenticatedRequest";

const DocumentDefinitionsEditorPage = () => {
  const { documentDefinitionId } = useParams();
  const navigate = useNavigate();
  const { get, post, put } = useAuthenticatedRequest();
  const [documentDefinition, setDocumentDefinition] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = documentDefinitionId === "new";

  const createEmptyDocumentDefinition = () => ({
    _id: crypto.randomUUID(),
    type: "",
    name: "",
    generalDirection: "",
    segments: [],
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchDocumentDefinition = async () => {
      if (isNew) {
        setDocumentDefinition(createEmptyDocumentDefinition());
        setLoading(false);
      } else {
        try {
          const response = await get(`https://documents.poc.mrc.ai/api/definitions/${documentDefinitionId}`);
          setDocumentDefinition(response.data);
        } catch (error) {
          console.error("Error fetching document definition:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDocumentDefinition();
  }, [documentDefinitionId, isNew]);

  const handleSave = async (updatedDocumentDefinition) => {
  try {
    const url = isNew
      ? `https://documents.poc.mrc.ai/api/definitions`
      : `https://documents.poc.mrc.ai/api/definitions/${documentDefinitionId}`;

    const response = isNew
      ? await post(url, updatedDocumentDefinition)
      : await put(url, updatedDocumentDefinition);

    setDocumentDefinition(response.data);
  } catch (err) {
    console.error("Error saving document definition:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <DocumentDefinitionsEditor documentDefinition={documentDefinition} onClose={handleClose} isNew={isNew} />;
};

export default DocumentDefinitionsEditorPage;
